// 新客 60 天 0 服務費（2026-09-01 后端上线）：后端在用户 exchrate_discount 配一条
// { erdType: 'PERCENT', erdDiscount: -0.0100, erdExpiredTime(秒) }，通过汇率优惠 1% 抵掉 1% 代购服务费。
// 有生效折扣时，预览/下单金额 dgAmtNTD 已按优惠结算、不再含 1% 服务费加成——
// 前端相应不再 /1.01 拆分、「服務費」显示 0、計費匯率直接显示结算汇率（不再 ×0.99）。
// 巧巧郎等无该字段的响应走原口径，行为不变。

// 判断 exchrate.exchrateDiscount 是否为生效中的服务费免除（PERCENT 负折扣且未过期）
export function hasExchrateFeeWaiver (exchrate) {
  const d = exchrate && exchrate.exchrateDiscount
  if (!d || d.erdType !== 'PERCENT') return false
  if (!(Number(d.erdDiscount) < 0)) return false
  if (d.erdExpiredTime && Number(d.erdExpiredTime) * 1000 < Date.now()) return false
  return true
}

// 代购金额 -> 商品金额（免服务费时金额本身即商品金额）
export function dgAmtToProductAmountWith (value, waived) {
  return waived ? Math.round(value) : Math.round(value / 1.01)
}

// 代购金额 -> 1% 服务费（免服务费时为 0）
export function dgAmtToFeeAmountWith (value, waived) {
  return waived ? 0 : Math.round((value / 1.01) * 0.01)
}

// 订单对象是否免服务费（后端在订单快照 dgExtras.exchrate.exchrateDiscount 下发；历史订单无该字段走原口径）
export function orderFeeWaived (order) {
  return hasExchrateFeeWaiver(order && order.dgExtras && order.dgExtras.exchrate)
}

// 订单 -> 商品金額（台币）
export function orderProductAmountNTD (order) {
  return dgAmtToProductAmountWith(Number(order && order.dgAmtNTD) || 0, orderFeeWaived(order))
}

// 订单 -> 1% 服務費（台币；免服务费订单为 0）
export function orderFeeAmountNTD (order) {
  return dgAmtToFeeAmountWith(Number(order && order.dgAmtNTD) || 0, orderFeeWaived(order))
}

// 结算汇率 -> 页面显示的計費匯率（未免除时剥掉 1% 服务费显示）
export function displayExchRate (rate, waived) {
  const r = Number(rate) || 0
  if (!r) return 0
  return Number((waived ? r : r * 0.99).toFixed(3))
}

// 订单 -> 页面显示的計費匯率（过滤器；免服务费订单直接显示结算汇率）
export function orderDisplayExchRate (order) {
  return displayExchRate(order && order.dgExchRate, orderFeeWaived(order))
}
